import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from '../cart.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';

@Component({
  selector: 'tea-shop-fe-checkout-status',
  standalone: false,
  
  templateUrl: './checkout-status.component.html',
  styleUrl: './checkout-status.component.css'
})
export class CheckoutStatusComponent implements OnInit {

  customerEmail: string | null = 'your email address';
  sessionId!: string;
  orderId!: string;

  isLoading = true;
  errors: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private cartService: CartService,
    private router: Router,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
  ) { 
    this.metaDataService.updateMetadata({
      title: 'Checkout Status',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnInit() {
    // Get the sessionId paremeter from the URL
    this.route.params.subscribe(params => {
      this.sessionId = params['sessionId'];
      this.cartService.retrieveCheckoutSession(this.sessionId).subscribe({
        next: (session) => {
          if (session.status === 'open') {
            this.router.navigate(['/checkout']);
            return;
          }
          this.isLoading = false;
          this.logger.log('CheckoutStatusComponent checkout', session);
          this.customerEmail = session.customer_email || session.customer_details.email;
          this.orderId = session.orderId;
          const clearCart = environment.production || confirm('Would you like to clear your cart? ');
          this.logger.log('clearCart', clearCart);
          if (clearCart) {
            this.cartService.clearCart();
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errors.push('An error occurred while retrieving the checkout session. Please try again shortly.');
          // this.errors.push(error.message);
          this.logger.error('An error occurred while retrieving the checkout session:', error);
        }
      });
    });
    this.logger.log('CheckoutStatusComponent ngOnInit');
  }

}
